import { useEffect } from 'react';
import getTracker from '@verdaccio/lrtrack-js';

import {
  REACT_APP_LR_TRACK_URL,
  REACT_APP_LR_TRACK_ID,
  IS_PROD,
} from './config';

const tracker = getTracker({
  trackerId: REACT_APP_LR_TRACK_ID || process.env.REACT_APP_LR_TRACK_ID,
  baseUrl: REACT_APP_LR_TRACK_URL || process.env.REACT_APP_LR_TRACK_URL,
  isDebug: !IS_PROD,
});

const useTrackValues = tracker.metrics.getUseTrackValues({ useEffect });
const trackClicks = tracker.metrics.trackClicks;
const trackValues = tracker.metrics.trackValues;

const storageGetItem = (key) =>
  tracker.utils.storageGetItem(tracker.utils.getStorageKey(key));

const storageSetItem = (key, payload) =>
  tracker.utils.storageSetItem(tracker.utils.getStorageKey(key), payload);

const setCid = (cid) => tracker.config.setCid(cid);

export {
  tracker as default,
  useTrackValues,
  trackClicks,
  trackValues,
  storageGetItem,
  storageSetItem,
  setCid,
};
